<div class="cookies" role="region" aria-label="Cookie consent">
  <div class="cookies__inner">
    <div class="cookies__content">
      This site uses cookies to offer you a better user experience.
    </div>
    <div class="cookies__buttons">
      <button class="btn btn--secondary" (click)="openCookieSettings.emit()">
        COOKIE SETTINGS
      </button>
      <button class="btn btn--secondary" (click)="reject()">Reject All</button>
      <button class="btn btn--primary" (click)="accept()">Accept All</button>
    </div>
  </div>
</div>
